import React from 'react';

import { useSelector } from 'hooks/useSelector';
import type { MayBe } from 'modules/global/typing/common/common';
import { getTimeZoneOffsetByDealerId } from 'selectors/dealerSelectors';

const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

type UseFormatTimeTimeZoneOptions = {
  dealerId?: string;
  systemTimezone?: boolean;
};

const useFormatTimeTimeZone = ({ dealerId, systemTimezone }: UseFormatTimeTimeZoneOptions = {}): Partial<Pick<Intl.DateTimeFormatOptions, 'timeZone'>> => {
  const tzSelector = React.useMemo(
    () => (dealerId && !systemTimezone
      ? (state: object) => (getTimeZoneOffsetByDealerId as (state: object, dealerId: string) => MayBe<string>)(state, dealerId)
      : () => undefined),
    [dealerId, systemTimezone]
  );

  const dealerTz = useSelector(tzSelector) as MayBe<string>;
  const timeZone = systemTimezone ? systemTz : dealerTz;
  return timeZone !== undefined ? { timeZone } : {};
};

export default useFormatTimeTimeZone;
